var EnvNgApp;
(function (EnvNgApp) {
    var Constants;
    (function (Constants) {
        //"use strict";
        Constants.AppName = "EnvNgApp";
        Constants.ModulesPrefix = "Modules";
        Constants.AppConfigName = Constants.AppName + ".Config";
        Constants.SearchBarGenerator = "EnvNgApp/Modules/GridConfigurator/GridConfiguratorService/Views/SearchBarGenerator.html";
        var AppRegisterItemType;
        (function (AppRegisterItemType) {
            AppRegisterItemType[AppRegisterItemType["ViewModel"] = 1] = "ViewModel";
            AppRegisterItemType[AppRegisterItemType["Directive"] = 2] = "Directive";
            AppRegisterItemType[AppRegisterItemType["Service"] = 3] = "Service";
            AppRegisterItemType[AppRegisterItemType["Constant"] = 4] = "Constant";
            AppRegisterItemType[AppRegisterItemType["Component"] = 5] = "Component";
        })(AppRegisterItemType = Constants.AppRegisterItemType || (Constants.AppRegisterItemType = {}));
    })(Constants = EnvNgApp.Constants || (EnvNgApp.Constants = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=appconstants.js.map